import React from 'react';
import { Button, Box, CircularProgress, IconButton, Dialog, DialogTitle, DialogContent, Typography, Paper } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

const DebugLogDialog = ({ 
    open, 
    onClose, 
    debugLog, 
    setDebugLog,
    loadingDebugLog, 
    setLoadingDebugLog,
    globalTenantId 
}) => {
    const handleRefresh = async () => {
        setLoadingDebugLog(true);
        try {
            const response = await axios.get(`/api/tenants/${globalTenantId}/debug-log`);
            setDebugLog(response.data.debugLog || 'No debug log available');
        } catch (error) {
            console.error('Error refreshing debug log:', error);
            alert('Failed to refresh debug log');
        } finally {
            setLoadingDebugLog(false);
        }
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(debugLog);
        alert('Debug log copied to clipboard!');
    };

    const handleClear = async () => {
        if (window.confirm('Are you sure you want to clear the debug log?')) {
            try {
                await axios.delete(`/api/tenants/${globalTenantId}/debug-log`);
                setDebugLog('');
                alert('Debug log cleared successfully');
                onClose();
            } catch (error) {
                console.error('Error clearing debug log:', error);
                alert('Failed to clear debug log');
            }
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Debug Log</Typography>
                    <Box>
                        <Button
                            onClick={handleRefresh}
                            variant="outlined"
                            disabled={loadingDebugLog}
                            sx={{ mr: 1 }}
                            startIcon={loadingDebugLog ? <CircularProgress size={16} /> : undefined}
                        >
                            {loadingDebugLog ? 'Refreshing...' : 'Refresh'}
                        </Button>
                        <Button
                            onClick={handleCopy}
                            variant="outlined"
                            sx={{ mr: 1 }}
                        >
                            Copy to Clipboard
                        </Button>
                        <Button
                            onClick={handleClear}
                            variant="outlined"
                            color="error"
                            sx={{ mr: 1 }}
                        >
                            Clear Log
                        </Button>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Paper 
                    elevation={0} 
                    sx={{ 
                        p: 2, 
                        backgroundColor: '#f5f5f5',
                        maxHeight: '500px',
                        overflow: 'auto'
                    }}
                >
                    <Typography 
                        component="pre" 
                        sx={{ 
                            fontFamily: 'monospace',
                            fontSize: '12px',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            margin: 0
                        }}
                    >
                        {debugLog}
                    </Typography>
                </Paper>
            </DialogContent>
        </Dialog>
    );
};

export default DebugLogDialog;

